import moment from "moment";
import { formatByType } from "./format";

const duration = (firstTime, lastTime) => {
  firstTime = firstTime * 1000;
  lastTime = lastTime * 1000;
  return moment.duration(moment(lastTime).diff(moment(firstTime)));
};

const latelyStr = (time, formatType) => {
  const dur = duration(time, Math.round(new Date().getTime() / 1000));
  const hourDur = parseInt(dur.asHours(), 10);
  if (hourDur >= 24) {
    return formatByType(time * 1000, formatType);
  }
  if (hourDur < 1) {
    const minDur = parseInt(dur.asMinutes(), 10);
    if (minDur > 30) {
      return "半小时前";
    }
    if (minDur > 1) {
      return `${minDur}分钟前`;
    }
    return "刚刚";
  }
  return `${hourDur}小时前`;
};

const getTimeRangeMS = (timeRange) => {
  const now = new Date().valueOf();
  switch (timeRange) {
    case "24h":
      return {
        start: now - 24 * 3600 * 1000,
        end: now,
      };
    case "7d":
      return {
        start: now - 7 * 24 * 3600 * 1000,
        end: now,
      };
    case "30d":
      return {
        start: now - 30 * 24 * 3600 * 1000,
        end: now,
      };

    default:
      return {
        start: now - 24 * 3600 * 1000,
        end: now,
      };
  }
};

const getCurrentTimeRange = (timeRange) => {
  const { start, end } = getTimeRangeMS(timeRange);
  return {
    start: Math.floor(start / 1000),
    end: Math.floor(end / 1000),
  };
};

export { duration, latelyStr, getTimeRangeMS, getCurrentTimeRange };
